<div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
        <svg-icon src="./assets/images/icons/close.svg"></svg-icon>
    </button>
</div>
<div class="modal-body text-center modal-bookfacility">
    <h4 class="font-weight-semibold mb-3 mb-md-4">Block Facility</h4>
    <form [formGroup]="myForm" (ngSubmit)="onSubmit()" class="text-left">

        <div class="row row-gap-4">
            <div class="col-12 d-flex flex-wrap row-gap-3 column-gap-4 column-gap-lg-5 column-gap-xl-6">
                <h6 class="mb-0 w-100">Booking Type</h6>
                <div class="custom-control custom-radio" *ngFor="let item of meetingRoomDetailsTypeData;let i = index">
                    <!-- <input type="radio" id="timeSlot{{i}}" value="{{item.facilityBookingTypeId}}"
                        class="custom-control-input" formControlName="bookingType"
                        (change)="selectBookingTypeId(item.facilityBookingTypeId, item.bookingTypeName)"
                        [(ngModel)]="bookingTypeHourDaily" [ngModelOptions]="{standalone: true}"> -->
                    <input type="radio" id="timeSlot{{i}}" [value]="item.facilityBookingTypeId"
                        class="custom-control-input" formControlName="bookingType"
                        (change)="selectBookingTypeId(item.facilityBookingTypeId, item.bookingTypeName)"
                        [(ngModel)]="bookingTypeHourDaily" [ngModelOptions]="{standalone: true}"
                        [attr.disabled]="isMeetingRoomEdit == 'yes' && bookingTypeHourDaily != item.facilityBookingTypeId ? true : null">
                    <label class="custom-control-label font-weight-semibold"
                        for="timeSlot{{i}}">{{item.bookingTypeName}}</label>
                </div>
                <div *ngIf="myForm.get('bookingType').invalid && myForm.get('bookingType').touched"
                    class="small text-danger">
                    <div *ngIf="myForm.get('bookingType').errors?.required">Booking type is required</div>
                </div>
            </div>
        </div>

        <div class="row row-gap-4 mb-4 mt-4" *ngIf="bookingTypeName=='Daily'">
            <div class="col-6 col-md-6 col-lg-6 d-flex flex-column row-gap-1">
                <div class="dp-hidden position-absolute">
                    <input name="datepicker" class="form-control" ngbDatepicker container="body"
                        #datepicker="ngbDatepicker" (click)="datepicker.toggle()" [markDisabled]="isDisabled"
                        [autoClose]="'outside'" (dateSelect)="onDateSelectionFrom($event)" [displayMonths]="1"
                        [dayTemplate]="t" outsideDays="hidden" [startDate]="fromDate!" [endDate]="toDate!" tabindex="-1"
                        [minDate]="minDate" [maxDate]="maxDate" [selectMultiple]="true"
                        [(ngModel)]="selectedDateRangeModel" [ngModelOptions]="{standalone: true}" />
                    <ng-template #t let-date let-focused="focused">
                        <span class="custom-day" [ngClass]="{'custom-datepicker': true}" [class.focused]="focused"
                            [class.range]="isRange(date)" [class.faded]="isHovered(date) || isInside(date)"
                            [class.disabled]="isDisabled(date)" [class.hovered]="isHovered(date)"
                            (mouseenter)="hoveredDate = date" (mouseleave)="hoveredDate = null">
                            {{ date.day }}
                        </span>
                    </ng-template>
                </div>
                <div class="form-group floating_form_field mb-0 w-100">
                    <input type="text" class="cal-icon all-hosts pt-3 hasDatepicker"
                        [placeholder]="currentDateToday ? currentDateToday : 'Start Date'" #dpFromDate
                        [value]="formatter.format(fromDate)"
                        (input)="fromDate = validateInput(fromDate, dpFromDate.value)"
                        (click)="datepicker.toggle(); openPopOver();" formControlName="fromDateToBook"
                        [(ngModel)]="startDateOnlyTextValue" [ngModelOptions]="{standalone: true}"
                        [ngClass]="{'custom-datepicker': true}" required readonly>
                    <label>Start Date</label>
                </div>
                <div class="d-flex justify-content-between">
                    <div *ngIf="myForm.get('fromDateToBook').invalid && myForm.get('fromDateToBook').touched"
                        class="small text-danger">
                        <div *ngIf="myForm.get('fromDateToBook').errors?.required">Start date is required
                        </div>
                    </div>
                </div>

                <!-- <div class="form-group floating_form_field mb-0 w-100">
                    <input class="cal-icon all-hosts pt-3 hasDatepicker" autocomplete="off" (click)="d1.toggle()"
                        (keypress)="$event.preventDefault()" [markDisabled]="isDisabled"
                        (dateSelect)="updateSelectedDateDaily($event)" id="fromDateToBook" type="text"
                        formControlName="fromDateToBook" ngbDatepicker container='body' #d1="ngbDatepicker"
                        [minDate]="minDate" required>
                    <label>
                        Start Date
                    </label>
                </div> -->

            </div>
            <div class="col-6 col-md-6 col-lg-6 d-flex flex-column row-gap-1">
                <div class="dp-hidden position-absolute">
                    <input name="datepickerto" class="form-control" ngbDatepicker container="body"
                        #datepickerto="ngbDatepicker" (click)="datepickerto.toggle()" [markDisabled]="isDisabled"
                        [autoClose]="'outside'" (dateSelect)="onDateSelection($event)" [displayMonths]="1"
                        [dayTemplate]="tf" outsideDays="hidden" [startDate]="fromDate!" [endDate]="toDate!"
                        tabindex="-1" [minDate]="minDate" [maxDate]="maxDate" [selectMultiple]="true"
                        [(ngModel)]="selectedDateRangeModelTo" [ngModelOptions]="{standalone: true}" readonly />
                    <ng-template #tf let-date let-focused="focused">
                        <span class="custom-day" [class.focused]="focused" [class.range]="isRange(date)"
                            [class.faded]="isHovered(date) || isInside(date)" [class.disabled]="isDisabled(date)"
                            [class.hovered]="isHovered(date)" (mouseenter)="hoveredDate = date"
                            (mouseleave)="hoveredDate = null">
                            {{ date.day }}
                        </span>
                    </ng-template>
                </div>
                <div class="form-group floating_form_field mb-0 w-100">
                    <input type="text" class="cal-icon all-hosts pt-3 hasDatepicker"
                        [placeholder]="currentDateToday ? currentDateToday : 'End Date'" #dpToDate
                        [value]="formatter.format(toDate)" (input)="toDate = validateInput(toDate, dpToDate.value)"
                        (click)="datepickerto.toggle(); openPopOver();" formControlName="toDateToBook"
                        [(ngModel)]="endDateOnlyTextValue" [ngModelOptions]="{standalone: true}" required readonly>
                    <label>End Date</label>
                </div>
                <div class="d-flex justify-content-between">
                    <div *ngIf="myForm.get('toDateToBook').invalid && myForm.get('toDateToBook').touched"
                        class="small text-danger">
                        <div *ngIf="myForm.get('toDateToBook').errors?.required">End date is required
                        </div>
                    </div>
                </div>

                <!-- <div class="form-group floating_form_field mb-0 w-100">
                    <input class="cal-icon all-hosts pt-3 hasDatepicker" autocomplete="off" (click)="d2.toggle()"
                        (keypress)="$event.preventDefault()" (dateSelect)="updateSelectedToDate($event)"
                        id="toDateToBook" type="text" formControlName="toDateToBook" ngbDatepicker container='body'
                        #d2="ngbDatepicker" [minDate]="minDate" required>
                    <label>
                        End Date
                    </label>
                </div> -->

            </div>
        </div>

        <div *ngIf="bookingTypeName=='Hourly'">
            <div class="row mt-4">
                <div class="col-12">

                    <div class="dp-hidden position-absolute">
                        <input name="datepickerh" class="form-control" ngbDatepicker container="body"
                            #datepickerh="ngbDatepicker" (click)="datepickerh.toggle()" [markDisabled]="isDisabled"
                            [autoClose]="'inside'" (dateSelect)="onDateSelectionFrom($event)" outsideDays="hidden"
                            [startDate]="fromDate!" [endDate]="toDate!" tabindex="-1" [minDate]="minDate"
                            [maxDate]="maxDate" />
                    </div>
                    <div class="form-group floating_form_field mb-0 w-100">
                        <input type="text" class="cal-icon all-hosts pt-3 hasDatepicker"
                            [placeholder]="currentDateToday ? currentDateToday : 'Start Date'" #dpFromDatehour
                            [value]="formatter.format(fromDate)"
                            (input)="fromDate = validateInput(fromDate, dpFromDatehour.value)"
                            (click)="datepickerh.toggle(); openPopOverHourly();" formControlName="toDateToBook"
                            [(ngModel)]="startDateOnlyTextValueHourly" [ngModelOptions]="{standalone: true}"
                            [ngClass]="{'custom-datepicker': true}" required readonly>
                        <label>Start Date</label>
                    </div>
                    <div class="d-flex justify-content-between">
                        <div *ngIf="myForm.get('toDateToBook').invalid && myForm.get('toDateToBook').touched"
                            class="small text-danger">
                            <div *ngIf="myForm.get('toDateToBook').errors?.required">Start date is required
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mt-2 mb-4" *ngIf="meetingRoomAlreadyBooked.length > 0">
                <div class="col-12 title-text" style="color: red; font-size: 14px;">
                    This facility is currently booked from
                </div>
                <div class="col-12 title-text"
                    *ngFor="let meetingroomtimeline of meetingRoomAlreadyBooked; let i=index;">
                    <div class="row">
                        <div class="col-12 title-text" style="color: red; font-size: 14px;">
                            {{meetingroomtimeline?.startTime}} to
                            {{meetingroomtimeline?.endTime}}.
                        </div>
                    </div>
                </div>
                <div class="col-12 title-text" style="color: red; font-size: 14px;">
                    Please choose an different time slot for your booking.
                </div>
            </div>
            <div class="row mt-4">
                <div class="col-6 pt-3 pb-3 borders-right" (clickOutside)="onClickedOutside($event)"
                    [autoClose]="'outside'" [ngbPopover]="popContent1" triggers="manual" #p1="ngbPopover"
                    (click)="openPopover(p1, normalizeTime)" placement="bottom" popoverClass='starttime-popover'
                    class="col-6 borders-right pt-2  pr-0 padding-left-start-time host-email-id">
                    <span class="host-email-id pt-3 start-time-pos">Start time</span>
                    <img src="/assets/images/clock-circular-outline.png" loading="lazy" />
                    <div class="all-hosts" style="padding-left: 2.5rem">{{display}}</div>
                    <ng-template #popContent1>
                        <div class="rectangle-copy-5">
                            <label class="start-time pl-4 pt-3">Start time</label>
                            <div class="pl-3 pr-4 pt-1 ">
                                <ngb-timepicker [(ngModel)]="normalizeTime" [ngModelOptions]="{standalone: true}"
                                    [meridian]="meridian" (ngModelChange)="onTimeChange($event)" [minuteStep]="15">
                                </ngb-timepicker>
                                <div>
                                    <span class="hh-margin">hh</span>
                                    <span class="mm-margin">mm</span>
                                </div>
                                <div class="toggle-position">
                                    <label class="switch">
                                        <input #saveamorpmCheckBox type="checkbox" id="saveamorpmCheckBox"
                                            [checked]="amorpm"
                                            (change)="toggleAmPmSelection(saveamorpmCheckBox.checked)">
                                        <span class="bookslider"></span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </div>
                <div class="col-6 pt-3 pb-3" (clickOutside)="onClickedOutside($event)" [autoClose]="'outside'"
                    [ngbPopover]="popContent2" triggers="manual" #p2="ngbPopover" (click)="openPopover(p2)"
                    placement="bottom" popoverClass='duration-popover'
                    class="col-6  pt-2  pr-0 padding-left-start-time host-email-id borders-without-right">
                    <span class="host-email-id pt-3 start-time-pos">Duration</span>
                    <img src="/assets/images/stopwatch.png" loading="lazy" />
                    <div class="all-hosts" *ngIf="duration==1" style="padding-left: 2.5rem">{{duration}} hour</div>
                    <div class="all-hosts" *ngIf="duration!=1" style="padding-left: 2.25rem;white-space: nowrap;">
                        {{displayDuration}}</div>
                </div>
                <ng-template #popContent2>
                    <div class=" rectangle">
                        <label class="start-time pl-4 pt-3">Duration</label>
                        <div class="pl-4 pr-4 pt-1 ">
                            <ngb-timepicker #dt [(ngModel)]="duration" [ngModelOptions]="{standalone: true}"
                                [meridian]="meridian" (ngModelChange)="onDurationChange($event)" [hourStep]="1"
                                [minuteStep]="30" [readonlyInputs]=true></ngb-timepicker>
                            <div>
                                <span class="hh-margin">hh</span>
                                <span class="mm-margin">mm</span>
                            </div>
                        </div>
                        <div class="pt-4 pl-2 pr-3 duration-text">
                            From {{display}} to {{displayTotalTime}}
                        </div>
                    </div>
                </ng-template>
            </div>
        </div>

        <div class="row row-gap-4 mb-4 mt-4 modalform">
            <div class="col-12 col-md-12 col-lg-12 d-flex flex-column row-gap-1">
                <div class="form-group floating_form_field mb-0 w-100">
                    <select class="form-control" formControlName="purpose" [(ngModel)]="meetingRoomBookingPurpose"
                        (change)="onChangePurpose($event)">
                        <option value="">Select Purpose</option>
                        <option value="{{lstpurpose.id}}" *ngFor="let lstpurpose of listOfPurpose">
                            {{lstpurpose.name}}
                        </option>
                    </select>
                    <label>Select Purpose</label>
                </div>
                <div *ngIf="myForm.get('purpose').invalid && myForm.get('purpose').touched" class="small text-danger">
                    <div *ngIf="myForm.get('purpose').errors?.required">Purpose is required
                    </div>
                </div>
            </div>

            <div class="col-12 col-md-12 col-lg-12 d-flex flex-column row-gap-1" *ngIf="reasonForOther">
                <div class="form-group floating_form_field mb-0 w-100">
                    <textarea class="form-control" formControlName="reason"
                        [(ngModel)]="meetingRoomBookingReason"></textarea>
                    <label>Reason</label>
                </div>
                <div *ngIf="myForm.get('reason').invalid && myForm.get('reason').touched" class="small text-danger">
                    <div *ngIf="myForm.get('reason').errors?.required">Reason is required
                    </div>
                </div>
            </div>
        </div>

        <p *ngIf="disanledButton" style="color: red;">{{messageForButtonDisable}}</p>
        <div class="d-flex align-items-center column-gap-3 mt-3 mt-md-4 mt-lg-5">
            <button class="btn btn-clear w-50" type="button" (click)="modal.dismiss()">Cancel</button>
            <button class="btn btn-primary w-50" type="submit" [disabled]="disanledButton">Submit</button>
        </div>
    </form>
</div>